export default __webpack_public_path__ + "static/media/locationIcon.2643226e.svg";